import { Radio } from "antd";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import Label from "shared/components/Label";
import Popover from "shared/components/Popover";

const findOptionValue = (raw, options) => {
  if (raw === undefined || raw === null || raw === "") {
    return undefined;
  }
  const found = (options || []).find((option) => {
    if (option.value === raw) return true;
    if (String(option.value) === String(raw)) return true;
    const isTrue = raw === true || raw === "true" || raw === 1 || raw === "1";
    const isFalse =
      raw === false || raw === "false" || raw === 0 || raw === "0";
    if (isTrue && (option.value === true || option.value === "true")) {
      return true;
    }
    if (isFalse && (option.value === false || option.value === "false")) {
      return true;
    }
    return false;
  });
  return found ? found.value : raw;
};

const Component = ({
  errors,
  touched,
  label,
  icon,
  onChange,
  values,
  value,
  required,
  optional,
  direction,
  defaultValue,
  ...rest
}) => {
  const [selectedValue, setSelectedValue] = useState(() =>
    findOptionValue(value ?? defaultValue, values),
  );

  useEffect(() => {
    setSelectedValue(findOptionValue(value ?? defaultValue, values));
  }, [defaultValue, value, values]);

  const onSelect = (event) => {
    const next = findOptionValue(event.target.value, values);
    setSelectedValue(next);
    onChange(next);
  };

  return (
    <div className={`radio-group__wrapper ${direction}`}>
      <Label
        label={label}
        icon={icon}
        required={required}
        optional={optional}
      />
      <div className="radio-group__wrapper--field">
        <Radio.Group
          onChange={onSelect}
          value={selectedValue}
          optionType="button"
          className="custom"
          {...rest}
        >
          {values.map(({ label: optionLabel, value: optionValue, popover }) => (
            <Radio
              value={optionValue}
              className={`custom--item  ${
                optionValue === selectedValue ? "checked" : ""
              }`}
              key={`radio-${optionValue}`}
            >
              {popover && <Popover text={popover} />}
              <p className="custom--label">{optionLabel}</p>
            </Radio>
          ))}
        </Radio.Group>
      </div>
      {touched && errors && <p className="input--errors">{errors}</p>}
    </div>
  );
};

Component.propTypes = {
  loading: PropTypes.bool,
  hidePlaceholder: PropTypes.bool,
  placeholder: PropTypes.node,
  onChange: PropTypes.func,
  values: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.any,
      value: PropTypes.any,
    }),
  ),
  value: PropTypes.any,
  defaultValue: PropTypes.any,
  errors: PropTypes.any,
  touched: PropTypes.bool,
  label: PropTypes.any,
  icon: PropTypes.any,
  required: PropTypes.bool,
  optional: PropTypes.bool,
  direction: PropTypes.string,
};

Component.defaultProps = {
  onChange: () => {},
  values: [],
};

export default Component;
